export default __webpack_public_path__ + "static/media/maniimg.d9be8b97.png";